import { Edit } from "@mui/icons-material";
import { IconButton, TableRow, Typography, TableCell } from "@mui/material";
import { CustomTooltip } from "components/CustomTooltip/CustomTooltip";
import React, { useMemo } from "react";

const RowItem = (props) => {
    const tooltipMessage = useMemo(() => {
        if(props.data.normalized == "Patient Name") return "Patient name should be in Last Name, First Name";
        else if (props.data.normalized == "Patient Date of Birth") return "Date of Birth should be in MM/DD/YYYY format";
        return ""
    }, [props.data.normalized])
    return <TableRow
        key={props.data.name}
        sx={{ 
            // '&:last-child td, &:last-child th': { border: 0 } 
            borderBottom: "1px solid rgba(224, 224, 224, 1)",
            "td": {
                padding: "unset !important"
            },
            ":hover": {
                cursor: "pointer",
            },
            // ":hover": {
            //     cursor: !props.data.modified ? "pointer" : "auto",
            // },
            // pointerEvents: !props.data.modified ? "auto" : "none"
        }}
        className="table-body-row"
        onClick={() => props.onRowClick(props.data)}
    >
        <TableCell scope="row">
            <div
                className={
                    props.data.modified === true
                        ? "card-flag"
                        : "card-flag-hide"
                }
            >
                <div className="tri-flag" />
            </div>
            <div className="cell-container">
                <Typography>{props.data.normalized}</Typography>
            </div>
        </TableCell>
        <TableCell scope="row">
            <div className="cell-container">
                <Typography>{props.data.key}</Typography>
            </div>
        </TableCell>
        <TableCell scope="row">
            <div className="cell-container">
                <Typography>{props.data.value}</Typography>
            </div>
        </TableCell>
        <TableCell align='center' sx={{
            pointerEvents: props.disableEdit ? "none" : "auto"
        }}>
                <CustomTooltip title={tooltipMessage} placement="top">
                    <IconButton>
                        <Edit className='icon-review-style' onClick={(e) => {
                            e.stopPropagation();
                            if (!props.disableEdit) props.handleEdit(props.id)
                        }} />
                    </IconButton>
                </CustomTooltip>
        </TableCell>
    </TableRow>
}

export default RowItem;